import { Injectable } from '@angular/core';
import { OrdersServiceAdapter } from '../../../../core/integrations/nosERP/services/orders.service';
import { AddItemToTable } from '../../../../core/integrations/nosERP/models/pos.model';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  constructor(private ordersServiceAdapter: OrdersServiceAdapter) {}

  addOrderItemToOrder(orderId: string, newItemPayload: AddItemToTable) {
    return this.ordersServiceAdapter.addOrderItemToOrder(newItemPayload);
  }
}
